import { InitialViewKeyType } from './constants';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const selectTipManagerCheckoutDrawerIsOpen = (state: any): boolean =>
  state.get('monetization').tipManagerCheckoutDrawer.isOpen;

export const selectInitialViewKey = (state: any): InitialViewKeyType =>
  state.get('monetization').tipManagerCheckoutDrawer.initialViewKey;
